import ApiClient from '../ApiClient';

class ClosureReasonsAPI extends ApiClient {
  constructor() {
    super('closure_reasons', {
      saas: true,
      accountScoped: true,
    });
  }
}

export default new ClosureReasonsAPI();
